declare let THREE: any;

export class RotationByYCalculator {

  private size = new THREE.Vector3();
  private left = new THREE.Vector3();
  private right = new THREE.Vector3();

  private calculateSize(object): void {
    const entity = object.userData.entity;
    if (entity) {
      this.size.set(entity.length, 0, entity.width);
    } else {
      const geometry = object.geometry;
      if (!geometry.boundingBox) {
        geometry.computeBoundingBox();
      }
      geometry.boundingBox.getSize(this.size);
    }
  }

  private calculateAngle(object): number {
    const {left, right, size} = this;
    left.set(-size.x / 2, 0, 0);
    right.set(size.x / 2, 0, 0);
    object.localToWorld(left);
    object.localToWorld(right);
    return -Math.atan2(right.z - left.z, right.x - left.x);
  }

  calculate(object): number {
    this.calculateSize(object);
    return this.calculateAngle(object);
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Class/RotationByYCalculator.ts